"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var Row_1 = __importDefault(require("./styledComponents/Row"));
var SavedSearchName_1 = __importDefault(require("./styledComponents/SavedSearchName"));
var NotificationOff_1 = __importDefault(require("./styledComponents/NotificationOff"));
var NotificationOn_1 = __importDefault(require("./styledComponents/NotificationOn"));
var Delete_1 = __importDefault(require("./styledComponents/Delete"));
var Paging_1 = __importDefault(require("../Paging/Paging"));
var IconInput_1 = __importDefault(require("../IconInput/IconInput"));
var Translate_1 = require("../Translate/Translate");
var SavedSearchList_meta_1 = require("./SavedSearchList.meta");
var mobx_1 = require("mobx");
var SavedSearchList = /** @class */ (function (_super) {
    __extends(SavedSearchList, _super);
    function SavedSearchList(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = SavedSearchList_meta_1.SAVED_SEARCH_LIST_CATEGORY_KEY;
        _this.componentKey = SavedSearchList_meta_1.SAVED_SEARCH_LIST_COMPONENT_KEY;
        return _this;
    }
    SavedSearchList.prototype.handleDelete = function (savedSearch) {
        var onDelete = this.props.onDelete;
        if (onDelete) {
            onDelete(savedSearch);
        }
    };
    SavedSearchList.prototype.handleClick = function (savedSearch) {
        var onClick = this.props.onClick;
        if (onClick) {
            onClick(savedSearch);
        }
    };
    SavedSearchList.prototype.handleToggleFrequency = function (savedSearch) {
        var onToggleFrequency = this.props.onToggleFrequency;
        if (onToggleFrequency) {
            var notificationFrequency = savedSearch.notificationFrequency;
            switch (notificationFrequency) {
                case 'off':
                    notificationFrequency = 'daily';
                    break;
                case 'daily':
                    notificationFrequency = 'weekly';
                    break;
                case 'weekly':
                    notificationFrequency = 'off';
                    break;
            }
            onToggleFrequency(savedSearch, notificationFrequency);
        }
    };
    SavedSearchList.prototype.renderSavedSearch = function (savedSearch, translationContext) {
        var _this = this;
        var notificationFrequency = savedSearch.notificationFrequency, savedSearchName = savedSearch.savedSearchName;
        var NotificationPill = notificationFrequency === 'off' ? NotificationOff_1.default : NotificationOn_1.default;
        var asset = notificationFrequency === 'off' ? 'base.savedSearchList.notificationOff' : 'base.savedSearchList.notificationOn';
        return (react_1.default.createElement(Row_1.default, null,
            react_1.default.createElement(SavedSearchName_1.default, { onClick: function () { return _this.handleClick(savedSearch); } }, savedSearchName),
            react_1.default.createElement(NotificationPill, { value: this.translateValue(translationContext, notificationFrequency), icon: { asset: asset }, onClick: function () { return _this.handleToggleFrequency(savedSearch); } }),
            react_1.default.createElement(Delete_1.default, { asset: 'base.savedSearchList.delete', onClick: function () { return _this.handleDelete(savedSearch); } })));
    };
    SavedSearchList.prototype.translateValue = function (translationContext, value) {
        return value ? translationContext.translate(value) : value;
    };
    SavedSearchList.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, paging = _a.paging, search = _a.search, _b = _a.savedSearches, savedSearches = _b === void 0 ? [] : _b;
        return (react_1.default.createElement(Wrapper_1.default, { className: className },
            react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
                if (search) {
                    search.placeholder = _this.translateValue(translationContext, search.placeholder);
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    search && react_1.default.createElement(IconInput_1.default, __assign({}, search)),
                    savedSearches.map(function (savedSearch) { return _this.renderSavedSearch(savedSearch, translationContext); }),
                    paging && react_1.default.createElement(Paging_1.default, __assign({}, paging))));
            })));
    };
    __decorate([
        mobx_1.action
    ], SavedSearchList.prototype, "handleDelete", null);
    __decorate([
        mobx_1.action
    ], SavedSearchList.prototype, "handleClick", null);
    __decorate([
        mobx_1.action
    ], SavedSearchList.prototype, "handleToggleFrequency", null);
    SavedSearchList = __decorate([
        mobx_react_1.observer
    ], SavedSearchList);
    return SavedSearchList;
}(shared_1.ComponentBase));
exports.SavedSearchList = SavedSearchList;
exports.default = shared_1.InjectedStyledComponent(SavedSearchList, SavedSearchList_meta_1.SAVED_SEARCH_LIST_CATEGORY_KEY, SavedSearchList_meta_1.SAVED_SEARCH_LIST_COMPONENT_KEY);
